import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useDeleteCandidate() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (candidateId) => {
      return axios.post(`/candidate/${candidateId}/delete`);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["candidates"] });
    },
  });
}
